/*
* @描述: 订单首页
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/12 16:11
*/
<template>
    <PullContainer ref="pullContainerRef" :pullDownLabel="true" :pullDownLoading="false">
        <template #container>
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="true" :isTitleNormal="true" title="返回">

                    </ReturnNavBar>
                </div>
                <div class="mobile_container index_statistics_wrap">
                    <div class="order_statistics_wrap">
                        <div class="flex_js_wrap">
                            <h3>订单</h3>
                            <div class="flex_wrap add_btn">
                                <span>新建</span>
                                <van-icon name="arrow"/>
                            </div>
                        </div>
                        <div v-if="statistics_data.today||statistics_data.yesterday" class="flex_js_wrap">
                            <div class="total_orders_wrap">
                                <div class="title">今日新增订单</div>
                                <div>
                                    <span class="total_num" v-text="statistics_data.today.total_orders"></span>
                                    <i v-if="Number(statistics_data.today.total_orders)<Number(statistics_data.yesterday.total_orders)"
                                       class="iconfont icon-xiajiang"></i>
                                    <i v-else class="iconfont icon-shangsheng"></i>
                                </div>
                                <div class="yesterday_text">
                                    昨日{{ statistics_data.yesterday.total_orders }}
                                </div>
                            </div>
                            <div class="total_amount_wrap">
                                <div class="title">今日新增订单金额</div>
                                <div>
                                    <span class="total_num"
                                          v-text="'¥'+Number(statistics_data.today.total_amount).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                    <i v-if="Number(statistics_data.today.total_amount)<Number(statistics_data.yesterday.total_amount)"
                                       class="iconfont icon-xiajiang"></i>
                                    <i v-else class="iconfont icon-shangsheng"></i>
                                </div>
                                <div class="yesterday_text">
                                    昨日{{
                                        Number(statistics_data.yesterday.total_amount).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="other_statistics_wrap">
                        <div v-if="statistics_data.today" class="flex_js_wrap statistics_data_wrap">
                            <div class="payment_wrap">
                                <div class="flex_js_wrap">
                                    <h3>回款</h3>
                                    <div class="flex_wrap add_btn">
                                        <span>新建</span>
                                        <van-icon name="arrow"/>
                                    </div>
                                </div>
                                <div class="today_repay_amount" v-text="statistics_data.today.today_repay_amount"></div>
                                <div class="text">今日回款</div>
                            </div>
                            <div class="invoice_wrap">
                                <div class="flex_js_wrap">
                                    <h3>开票</h3>
                                    <div class="flex_wrap add_btn">
                                        <span>新建</span>
                                        <van-icon name="arrow"/>
                                    </div>
                                </div>
                                <div class="today_invoice_amount"
                                     v-text="statistics_data.today.today_invoice_amount"></div>
                                <div class="text">今日开票</div>
                            </div>
                        </div>
                        <div class="expire_goods_wrap">
                            <h3>订单产品归还提醒</h3>
                            <ul class="expire_goods_list">
                                <li v-for="(item,index) in expire_goods" class="expire_goods_item">
                                    <div class="flex_js_wrap">
                                        <div class="goods_names"
                                             v-text="item.goods.map(goods=>goods.goods_name).join('、')"></div>
                                        <div class="count" v-text="'共'+item.count+'个产品'"></div>
                                    </div>
                                    <div class="flex_js_wrap">
                                        <div class="flex_wrap">
                                            <span class="order_text">来自订单：</span>
                                            <span class="order_num" @click="handleClickOrderDetail(item.order_num)"
                                                  v-text="item.order_num"></span>
                                        </div>
                                        <div :class="{'today_expire':item.max_expire_day===0}"
                                             class="max_expire_day"
                                             v-text="item.max_expire_day===0?'今天过期':'已过期'+item.max_expire_day+'天'"></div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <FooterTabbar :tabBarActive="tabBarActive" :tabBarList="tabBarList"></FooterTabbar>
            </div>
        </template>
    </PullContainer>
</template>
<script>
import {EventBus} from '@/utils/eventBus';
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import {orderIndexStatistics} from "@/api";

export default {
    name: "Order",
    data() {
        return {
            loading: false,
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "Order",
                    title: "首页",
                },
                {
                    icon: "icon-a-dingdan1",
                    activeIcon: "icon-a-dingdan26",
                    routerName: "OrderList",
                    title: "订单",
                },
                {
                    icon: "icon-tuikuan",
                    activeIcon: "icon-tuikuan1",
                    routerName: "PaymentList",
                    title: "回款",
                },
                {
                    icon: "icon-fapiao",
                    activeIcon: "icon-a-fapiao1",
                    routerName: "InvoiceList",
                    title: "开票",
                },
            ],
            tabBarActive: 0,
            expire_goods: [],
            statistics_data: {}
        }
    },
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar
    },
    created() {
        this.loading = true
        orderIndexStatistics().then(res => {
            if (res.code === 200) {
                const {statistics_data, expire_goods} = res.data
                this.statistics_data = statistics_data
                this.expire_goods = expire_goods
            }
            this.loading = false
        })
    },
    computed: {},
    mounted() {

    },
    methods: {
        handleClickOrderDetail(order_num) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: order_num,
                    order_num: order_num,
                },
            });
        },
    },
    beforeDestroy() {
        EventBus.$off('orderUpdated', this.getOrderTableList);
    },
}
</script>
<style lang="scss" scoped>
.index_statistics_wrap {
    padding: 10px 16px;

    .order_statistics_wrap {
        margin-bottom: 10px;
        padding: 12px;
        width: 100%;
        height: 142px;
        border-radius: 4px;
        background: url("https://download.hecoos.com/enlightv/2025-10/4f9df466c1d4df89afafec128b6b8d7c.png") no-repeat;
        background-size: 100% 100%;

        .total_orders_wrap {
            width: calc(50% - 5px);
            height: 86px;
            padding: 8px;
            border-radius: 6px;
            margin-top: 8px;
            background: url("https://download.hecoos.com/enlightv/2025-10/a9520046392f3fe767df80655bb7ac95.png") no-repeat;
            background-size: 100% 100%;
        }

        .total_amount_wrap {
            width: calc(50% - 5px);
            height: 86px;
            padding: 8px;
            border-radius: 6px;
            margin-top: 8px;
            background: url("https://download.hecoos.com/enlightv/2025-10/61452d90803762a36faa88bd781fbd78.png") no-repeat;
            background-size: 100% 100%;
        }

        .title {
            font-size: 12px;
            font-weight: 700;
            line-height: 18px;
            color: #333333;
            margin-bottom: 6px;
        }

        .total_num {
            font-size: 18px;
            font-weight: 700;
            line-height: 26px;
            color: #2990FF;
        }

        .yesterday_text {
            font-size: 12px;
            line-height: 18px;
            color: #666666;
            margin-top: 2px;
        }

        .icon-xiajiang {
            color: #5AB333;
            margin-left: 2px;
        }

        .icon-shangsheng {
            color: #E44144;
            margin-left: 2px;
        }
    }

    .other_statistics_wrap {
        min-height: calc(100% - 215px);
        margin-top: 63px;
        background: linear-gradient(180deg, rgba(255, 242, 243, 1) 0%, rgba(255, 255, 255, 1) 100%);
        position: relative;
        padding-top: 63px;

        .statistics_data_wrap {
            width: 100%;
            position: absolute;
            top: -52px;
            left: 0;
        }

        .payment_wrap {
            width: calc(50% - 5px);
            height: 104px;
            padding: 12px;
            background: url("https://download.hecoos.com/enlightv/2025-10/5561b0592d9c549f9d9eaa18b50af912.png") no-repeat;
            background-size: 100% 100%;
            border-radius: 4px;

            .today_repay_amount {
                font-size: 18px;
                font-weight: 700;
                line-height: 26px;
                color: #5AB333;
                margin-top: 10px;
            }

            .text {
                font-size: 12px;
                line-height: 18px;
                color: #666666;
                margin-top: 2px;
            }
        }

        .invoice_wrap {
            width: calc(50% - 5px);
            height: 104px;
            padding: 12px;
            background: url("https://download.hecoos.com/enlightv/2025-10/ffd89b02d41e4fc88c8a719cac59613b.png") no-repeat;
            background-size: 100% 100%;
            border-radius: 4px;

            .today_invoice_amount {
                font-size: 18px;
                font-weight: 700;
                line-height: 26px;
                color: #F0AA32;
                margin-top: 10px;
            }

            .text {
                font-size: 12px;
                line-height: 18px;
                color: #666666;
                margin-top: 2px;
            }
        }

        .expire_goods_wrap {
            padding: 12px;

            .expire_goods_list {
                margin-top: 16px;

                .expire_goods_item {
                    padding: 10px 0;
                    border-bottom: 1px solid #E8E8E8;

                    .goods_names {
                        font-size: 12px;
                        font-weight: 700;
                        line-height: 18px;
                    }

                    .count {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 18px;
                        color: #999999;
                    }

                    .order_text {
                        font-size: 12px;
                        line-height: 18px;
                        color: #666666;
                    }

                    .order_num {
                        font-size: 12px;
                        color: #2990FF;
                        line-height: 18px;
                    }

                    .max_expire_day {
                        font-size: 12px;
                        line-height: 18px;
                        color: #E44144;

                        &.today_expire {
                            color: #F0AA32;
                        }
                    }
                }
            }
        }
    }

    .add_btn {
        color: #666666;
    }
}
</style>